import useApi from "./useApiRequest";
import { useMutation } from "react-query";

export const GetAllAlmacenes = ()  => {
    const api = useApi();

    const mutate = async (params) => {
        const data  = await api.get(`/almacenes?alma_nombre=${params.alma_nombre}`);
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        getAllAlmacenesMutation: mutation.mutate,
    };
}